import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import ContentCard from "../../common/template/contentCard";
import ContentCardHeader from "../../common/template/contentCardHeader";
import Row from "../../common/layout/row";
import Grid from "../../common/layout/grid";
import Button from "../../common/button/button";
import ButtonTable from "../../common/table/buttonTable";
import Select from "../../common/form/select";
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_dark from "@amcharts/amcharts4/themes/dark.js";
import confirmDialog from "../../common/dialog/confirmDialog";
import LabelAndCheckbox from "../../common/form/labelAndCheckbox";
import {
    setFiltro,
    getListaAnosEmpenho,
    buscaCusd,
    getListaGraficoCustoAnual,
    getListaGraficoConsumoAnual,
    getListaGraficoValorDevolvidoAnual,
    getListaGraficoCustoMultaAnual,
    getListaGraficoCustoReativoAnual,
    getListaGraficoConsumoForaPonta,
    getListaAnaliseCativoMercadoLivreMensal,
    getListaContratosAluguelHistorico,
    getListaGeradorasContratosAluguelHistorico,
} from "../analiseActions";
import ampulhetaCirculo from "../../assets/images/ampulheta_circulo.png";
import { setArquivoPDF } from "../../displayPDF/displayPDFActions";
import { buscarPdfUnifilarRedeInterna } from "../../rede/redeActions";
import { buscarPdf } from "../../demandaContrato/demandaContratoActions";
import {} from "../../cliente/clienteActions";
import { buscarArquivoContrato } from "../../contratoAluguel/contratoAluguelActions";
import { setError } from "../../common/toast/toast";
import BotaoExcluir from "../../common/button/botaoExcluir";
import Toggle from "../../common/form/toggle";
import { LabelSelectUcIconeGestor } from "../../common/form/LabelSelectUcIconeGestor";

function FiltrosAnaliseComponent(props) {
    const [contratosAntesDefinirFiltroRemota, setContratosAntesDefinirFiltroRemota] = useState(props.contratosAluguel || []);
    const [analisarRemotaIndividualContratoAluguel, setAnalisarRemotaIndividualContratoAluguel] = useState(false);
    useEffect(() => {
        const ids = props.contratosAluguel.map((ca) => ca.id);
        const idsFiltro = props.filtro.ids_contrato_aluguel_historico;

        // se já está sincronizado, não faz nada
        if (idsFiltro.length === ids.length && ids.every((id) => idsFiltro.includes(id))) {
            return;
        }

        props.setFiltro({
            ...props.filtro,
            id_unidade_geradora_contrato_aluguel: null,
            id_contrato_aluguel_historico: null,
            ids_contrato_aluguel_historico: ids,
        });
    }, [props.contratosAluguel]);

    useEffect(() => {
        //reseta campos de análise individual quando não tem mais contratos no
        if (!props.contratosAluguel.length) {
            props.setFiltro({ ...props.filtro, id_unidade_remota_contrato_aluguel: null });
            setAnalisarRemotaIndividualContratoAluguel(false);
        }
    }, [contratosAntesDefinirFiltroRemota]);

    //quando altera os ids do filtro do redux, atualiza o state local de contratos
    useEffect(() => {
        const ids = props.filtro.ids_contrato_aluguel_historico;
        const listaContratosAluguelAtualizada = props.contratosAluguel.filter((ca) => ids.includes(ca.id));
        props.atualizarState({ contratosAluguel: listaContratosAluguelAtualizada });
    }, [props.filtro.ids_contrato_aluguel_historico]);

    useEffect(() => {
        if (!props.filtro.ids_contrato_aluguel_historico.length) return;
        props.handleAtualizar();
    }, [props.filtro.id_unidade_remota_contrato_aluguel]);

    //UCs que listam no select do primeiro filtro  de UCS
    function listarUCsFiltradas() {
        return props.listaUnidadeConsumidora.filter((item) => {
            //se não selecionar cliente não traz UCs
            const filtroClienteValidado = !props.filtro.id_cliente || item.id_cliente == props.filtro.id_cliente;

            const filtroGrupoFaturamento = props.filtro.grupos_faturamento.map((item) => parseInt(item.value)); //apenas os ids do filtro

            const filtroGrupoFaturamentoValidado = !filtroGrupoFaturamento.length || filtroGrupoFaturamento.includes(item.id_grupo_faturamento);
            const filtroIrriganteValidado = (props.filtro.irrigante && item.irrigante) || (props.filtro.naoIrrigante && !item.irrigante);

            if (["reativo", "multas"].includes(props.tabSelecionada)) {
                return filtroClienteValidado && ([1, 4].includes(parseInt(item.id_grupo_faturamento)) || item.id_grupo_faturamento == 3);
            }

            if (["demanda"].includes(props.tabSelecionada)) {
                return filtroClienteValidado && [1, 4].includes(parseInt(item.id_grupo_faturamento));
            }

            if (["mercadoLivre"].includes(props.tabSelecionada)) {
                return filtroClienteValidado && item.id_tipo_mercado == 2;
            }

            if (props.tabSelecionada === "horario") {
                return filtroClienteValidado && ([1, 4].includes(parseInt(item.id_grupo_faturamento)) || item.id_grupo_faturamento == 3 || item.irrigante);
            }

            if (props.tabSelecionada === "excedente") {
                return filtroClienteValidado && (item.geracao || item.remota);
            }

            //se não for nenhum dos anteriores
            return filtroClienteValidado && filtroGrupoFaturamentoValidado && filtroIrriganteValidado;
        });
    }

    am4core.useTheme(am4themes_dark);

    const currentYear = new Date().getFullYear();
    const modoSafra = props.filtro[`${props.tabSelecionada}_ano_safra`];
    const listaAnos = Array.from({ length: 20 }, (_, i) => {
        const year = currentYear - i; // inverte a ordem
        return {
            id: year.toString(),
            valor: modoSafra ? `${year}/${year + 1}` : year.toString(),
        };
    });

    const idClienteUsuario = props.usuarioLogado ? props.usuarioLogado.id_cliente : null;
    const existeUcIrriganteUcsCliente = props.listaUnidadeConsumidora.find((uc) => uc.id_cliente == idClienteUsuario && uc.irrigante);
    const exibirFiltroIrrigante = props.usuarioLogado.administrador || existeUcIrriganteUcsCliente;

    const semAcessoAbas =
        !props.usuarioLogado ||
        (!props.usuarioLogado.acesso_modulo_analise_custo &&
            !props.usuarioLogado.acesso_modulo_analise_consumo &&
            !props.usuarioLogado.acesso_modulo_analise_tarifa &&
            !props.usuarioLogado.acesso_modulo_analise_aproveitamento_consumo_horario &&
            !props.usuarioLogado.acesso_modulo_analise_demanda &&
            !props.usuarioLogado.acesso_modulo_analise_multa &&
            !props.usuarioLogado.acesso_modulo_analise_micro_mini_geracao &&
            !props.usuarioLogado.acesso_modulo_analise_empenho &&
            !props.usuarioLogado.acesso_modulo_analise_devolucao &&
            !props.usuarioLogado.acesso_modulo_analise_mercado_livre &&
            !props.usuarioLogado.acesso_modulo_analise_contrato_aluguel_usina &&
            !props.usuarioLogado.acesso_modulo_analise_reativo);

    const umaUcSelecionadaNoFiltro = props.filtro.unidades_consumidoras.length == 1;

    const primeiroItemHistorico = ((props.contratoDemanda || {}).historico || [])[0] || {};
    const ultimoRegistroEmAndamento = primeiroItemHistorico.status === "Em andamento" || primeiroItemHistorico.status === "Iniciada";

    if (semAcessoAbas) return null;

    const remotasContratosAluguel = contratosAntesDefinirFiltroRemota.reduce((acc, current) => {
        acc.push(...current.unidadesRemotas);
        return acc;
    }, []);

    return (
        <ContentCard>
            <ContentCardHeader>
                <Row>
                    {props.usuarioLogado && !props.usuarioLogado.acesso_cliente ? (
                        <Select
                            paddingTop={props.tabSelecionada === "contratoAluguel" ? 14 : null}
                            name="id_cliente"
                            options={props.listaCliente}
                            label="Cliente"
                            cols={
                                ["mercadoLivre"].includes(props.tabSelecionada)
                                    ? "12 12 10 10"
                                    : ["demanda"].includes(props.tabSelecionada)
                                      ? "12 12 8 8"
                                      : props.tabSelecionada === "contratoAluguel"
                                        ? "12 12 4 4"
                                        : "12 12 5 5"
                            }
                            placeholder="Selecione o Cliente"
                            value={props.filtro.id_cliente}
                            onChange={(value) => {
                                props.setFiltro({
                                    ...props.filtro,
                                    id_cliente: value,
                                    id_unidade_consumidora: null,
                                    id_unidade_geradora_contrato_aluguel: null,
                                    ids_contrato_aluguel_historico: [],
                                    unidades_consumidoras: [],
                                    unidades_custo_anual: [],
                                    unidades_custo_anual_periodo_safra: [],
                                });
                                if (props.tabSelecionada === "empenho") props.getListaAnosEmpenho();
                                if (props.tabSelecionada === "custo") props.getListaGraficoCustoAnual();
                                if (props.tabSelecionada === "consumo") props.getListaGraficoConsumoAnual();
                                if (props.tabSelecionada === "devolucao") props.getListaGraficoValorDevolvidoAnual();
                                if (props.tabSelecionada === "multas") props.getListaGraficoCustoMultaAnual();
                                if (props.tabSelecionada === "reativo") props.getListaGraficoCustoReativoAnual();
                                if (props.tabSelecionada === "horario") props.getListaGraficoConsumoForaPonta();
                                if (props.tabSelecionada === "mercadoLivre") props.getListaAnaliseCativoMercadoLivreMensal();
                                if (props.tabSelecionada === "contratoAluguel") {
                                    props.getListaGeradorasContratosAluguelHistorico();
                                    props.getListaContratosAluguelHistorico();
                                }
                            }}
                        />
                    ) : null}

                    {props.tabSelecionada === "mercadoLivre" && (
                        <Select
                            cols="12 12 2 2"
                            name="ano_mercado_livre"
                            // VERIFICAR QUAIS ANOS PODEM SER
                            options={listaAnos}
                            label="Ano"
                            placeholder="Selecione o ano"
                            value={props.filtro.ano_mercado_livre}
                            isClearable={false}
                            isSearchable={false}
                            onChange={(value) => {
                                props.setFiltro({ ...props.filtro, ano_mercado_livre: value });
                            }}
                        />
                    )}

                    {props.tabSelecionada === "empenho" ? (
                        <Select
                            cols="12 12 5 5"
                            name="ano_referencia"
                            // VERIFICAR QUAIS ANOS PODEM SER
                            options={props.listaAnosEmpenho}
                            label="Ano de referência do Empenho"
                            placeholder="Selecione o ano de referência do empenho"
                            value={props.filtro.ano_referencia}
                            isClearable={false}
                            isSearchable={false}
                            onChange={(value) => {
                                props.setFiltro({ ...props.filtro, ano_referencia: value });
                            }}
                        />
                    ) : (
                        <>
                            {props.tabSelecionada === "demanda" ? (
                                <Select
                                    name="demanda_contrato_tipos"
                                    options={props.listaDemandaContratoTipo.filter((tipo) => {
                                        const ucFiltradaPeloCliente = props.listaUnidadeConsumidora.filter((uc) => uc.id_cliente == props.filtro.id_cliente);
                                        const condicaoForaPonta = tipo.id == 1;
                                        const condicaoPonta = tipo.id == 2 && !!ucFiltradaPeloCliente.find((uc) => uc.id_modalidade_tarifaria == 2); //alguma uc do cliente selecionado tem q ser horosazonal azul
                                        const condicaoGeracao =
                                            tipo.id == 3 && !!ucFiltradaPeloCliente.find((uc) => uc.geracao && [1, 4].includes(parseInt(uc.id_grupo_faturamento))); //alguma uc do cliente selecionado tem q ser geradora e grupo A
                                        return condicaoForaPonta || condicaoPonta || condicaoGeracao;
                                    })}
                                    label="Tipo de Contrato de Demanda"
                                    cols="12 12 4 4"
                                    placeholder="Selecione o tipo de contrato de demanda"
                                    value={props.filtro.id_tipo_contrato_demanda}
                                    isClearable={false}
                                    isSearchable={false}
                                    onChange={(id_tipo_contrato_demanda) => {
                                        props.setFiltro({
                                            ...props.filtro,
                                            id_tipo_contrato_demanda,
                                        });
                                    }}
                                />
                            ) : props.tabSelecionada === "mercadoLivre" ? null : props.tabSelecionada === "contratoAluguel" ? (
                                <>
                                    <Grid cols={props.contratosAluguel.length ? "12 12 6 6" : "12 12 8 8"} style={{ padding: 10 }}>
                                        <Row style={{ backgroundColor: "#d9e1ee", border: "2px solid #bbc9e0", borderRadius: 5 }}>
                                            <Select
                                                readOnly={!props.filtro.id_cliente}
                                                name="id_unidade_geradora_contrato_aluguel"
                                                options={props.listaGeradorasContratoAluguelHistorico.filter(
                                                    (cg) => !props.contratosAluguel.find((ca) => ca.id_unidade_geradora == cg.id)
                                                )}
                                                label="Unidade Geradora do Contrato"
                                                cols={"12 12 4 4"}
                                                placeholder="Selecione a UC geradora"
                                                value={props.filtro.id_unidade_geradora_contrato_aluguel}
                                                isClearable={true}
                                                isSearchable={true}
                                                onChange={(id_unidade_geradora_contrato_aluguel) => {
                                                    props.setFiltro({
                                                        ...props.filtro,
                                                        id_unidade_geradora_contrato_aluguel,
                                                        id_contrato_aluguel_historico:
                                                            id_unidade_geradora_contrato_aluguel === null ? null : props.filtro.id_contrato_aluguel_historico,
                                                    });
                                                }}
                                            />
                                            <Select
                                                readOnly={!props.filtro.id_cliente}
                                                name="id_contrato_aluguel_historico"
                                                options={props.listaContratoAluguelHistorico.filter(
                                                    (c) =>
                                                        !props.contratosAluguel.find((ca) => ca.id == c.id) &&
                                                        c.id_unidade_geradora == props.filtro.id_unidade_geradora_contrato_aluguel
                                                )}
                                                label="Período do Contrato"
                                                cols={"12 12 4 4"}
                                                placeholder="Selecione o período"
                                                value={props.filtro.id_contrato_aluguel_historico}
                                                isClearable={true}
                                                isSearchable={false}
                                                onChange={(id_contrato_aluguel_historico) => {
                                                    props.setFiltro({
                                                        ...props.filtro,
                                                        id_contrato_aluguel_historico,
                                                    });
                                                }}
                                            />

                                            <Grid cols="12 12 4 4" style={{ paddingTop: 28, paddingRight: 15 }}>
                                                <Button
                                                    text="Incluir na análise"
                                                    type={"dark"}
                                                    icon={"fa fa-plus"}
                                                    event={() => {
                                                        const listaContratosAluguelAtualizada = [...props.contratosAluguel];
                                                        const contratoSelecionado = props.listaContratoAluguelHistorico.find(
                                                            (cah) => cah.id == props.filtro.id_contrato_aluguel_historico
                                                        );
                                                        if (!contratoSelecionado) return setError("Não foi possível localizar o contrato de aluguel");

                                                        //se nao tem grupo, só vai ter um, se tem, vai adicionar todos do grupo no filtro
                                                        let contratosParaIterar = [contratoSelecionado];
                                                        if (contratoSelecionado.ids_contratos_aluguel_historico_mesmo_grupo.length) {
                                                            contratosParaIterar = props.listaContratoAluguelHistorico.filter((cah) => {
                                                                const idsListaContratosAtual = props.contratosAluguel.map((c) => c.id);
                                                                const fazParteDoGrupo = contratoSelecionado.ids_contratos_aluguel_historico_mesmo_grupo.includes(cah.id);
                                                                const aindaNaoEstaNaLista = !idsListaContratosAtual.includes(cah.id);
                                                                return fazParteDoGrupo && aindaNaoEstaNaLista;
                                                            });
                                                        }

                                                        for (const contrato of contratosParaIterar) {
                                                            const periodo = contrato.valor;
                                                            const unidadeGeradora = props.listaGeradorasContratoAluguelHistorico.find(
                                                                (ug) => ug.id == contrato.id_unidade_geradora
                                                            );
                                                            if (!unidadeGeradora) return setError("Não foi possível localizar a unidade geradora do contrato de aluguel");
                                                            const unidadesRemotas = contrato.ids_unidades_remotas;

                                                            listaContratosAluguelAtualizada.push({
                                                                ...contrato,
                                                                periodo,
                                                                unidadeGeradora: unidadeGeradora.valor,
                                                                unidadesRemotas,
                                                            });
                                                        }
                                                        props.atualizarState({ contratosAluguel: listaContratosAluguelAtualizada });
                                                        setContratosAntesDefinirFiltroRemota(listaContratosAluguelAtualizada);
                                                    }}
                                                />
                                            </Grid>
                                        </Row>
                                    </Grid>
                                    {props.contratosAluguel.length ? (
                                        <Grid cols="12 12 2 2" style={{ paddingTop: 28, paddingRight: 15 }}>
                                            <Button
                                                text="Analisar"
                                                type={"primary"}
                                                icon={"fa fa-sync"}
                                                event={() => {
                                                    if (!props.filtro.ids_contrato_aluguel_historico.length) {
                                                        return setError("Inclua ao menos um contrato para atualizar a análise");
                                                    }
                                                    props.handleAtualizar();
                                                }}
                                            />
                                        </Grid>
                                    ) : null}

                                    {props.contratosAluguel.length ? (
                                        <Grid cols={"12 12 12 12"}>
                                            <Toggle
                                                checked={analisarRemotaIndividualContratoAluguel}
                                                onChange={(value) => {
                                                    setAnalisarRemotaIndividualContratoAluguel(value);
                                                    //armazena lista temporaria, pra quando remover a remota do filtro volta os contratos como estavam
                                                    if (!value) {
                                                        props.setFiltro({ ...props.filtro, id_unidade_remota_contrato_aluguel: null });
                                                        props.atualizarState({ contratosAluguel: contratosAntesDefinirFiltroRemota });
                                                    }
                                                }}
                                                fontColor="#222"
                                                label="Analisar Unidade Remota Individualmente"
                                            />
                                        </Grid>
                                    ) : null}
                                    {analisarRemotaIndividualContratoAluguel && (
                                        <Select
                                            name="id_unidade_remota_contrato_aluguel"
                                            options={props.listaUnidadeConsumidora.filter((uc) => {
                                                const estaNaListaDeRemotas = remotasContratosAluguel.find((r) => r.value == uc.id);
                                                return estaNaListaDeRemotas;
                                            })}
                                            label={
                                                <LabelSelectUcIconeGestor
                                                    text="Unidade Remota"
                                                    filtro={props.filtro}
                                                    listaUnidadeConsumidora={props.listaUnidadeConsumidora}
                                                    setExibirModal={(ucFiltro) => props.atualizarState({ exibirModalGestorConcessionaria: true, itemSelecionado: ucFiltro })}
                                                />
                                            }
                                            cols="12 12 4 4"
                                            placeholder="Selecione a unidade remota"
                                            value={props.filtro.id_unidade_remota_contrato_aluguel}
                                            onChange={(value) => {
                                                props.setFiltro({ ...props.filtro, id_unidade_remota_contrato_aluguel: value });

                                                if (!value) {
                                                    props.atualizarState({ contratosAluguel: contratosAntesDefinirFiltroRemota });
                                                    return;
                                                }

                                                const listaContratosContendoARemota = contratosAntesDefinirFiltroRemota.filter((c) =>
                                                    c.unidadesRemotas.find((r) => r.value == value)
                                                );
                                                const contratosRemotasFiltradas = listaContratosContendoARemota.map((c) => ({
                                                    ...c,
                                                    unidadesRemotas: c.unidadesRemotas.filter((r) => r.value == value),
                                                }));
                                                props.atualizarState({ contratosAluguel: contratosRemotasFiltradas });
                                            }}
                                        />
                                    )}
                                    <Grid cols="12 12 12 12">
                                        <Row style={{ padding: 8 }}>
                                            <div>
                                                <b className="mt-3">Contratos da Análise:</b>
                                            </div>
                                            {props.contratosAluguel.length ? (
                                                props.contratosAluguel.map((contrato) => {
                                                    return (
                                                        <Grid key={contrato.id} cols="12 12 12 12" style={{ border: "1px solid #DDD", borderRadius: "0.3rem", padding: 5 }}>
                                                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                                                <div style={{ flexGrow: 1 }}>
                                                                    <b>Período:</b> {contrato.periodo}
                                                                </div>

                                                                <BotaoExcluir
                                                                    title="Remover da análise"
                                                                    event={() => {
                                                                        const listaContratosAluguelAtualizada = props.contratosAluguel.filter((ca) => ca.id != contrato.id);
                                                                        props.atualizarState({ contratosAluguel: listaContratosAluguelAtualizada });
                                                                        setContratosAntesDefinirFiltroRemota(listaContratosAluguelAtualizada);
                                                                    }}
                                                                />
                                                            </div>
                                                            <div style={{ display: "flex" }}>
                                                                <div style={{ flexGrow: 1 }}>
                                                                    <b>Unidade Geradora:</b> {contrato.unidadeGeradora} <br />
                                                                    <b>Unidades Remotas:</b>
                                                                    <div style={{ display: "flex" }}>
                                                                        {contrato.unidadesRemotas.map((remota, index, remotas) => (
                                                                            <div key={remota.value}>
                                                                                <span
                                                                                    style={{
                                                                                        backgroundColor: "#d9e1ee",
                                                                                        border: "2px solid #bbc9e0",
                                                                                        borderRadius: "0.3rem",
                                                                                        padding: 4,
                                                                                    }}
                                                                                >
                                                                                    {remota.label}
                                                                                </span>
                                                                                <span className="mr-2">{index < remotas.length - 1 ? "," : ""}</span>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                    <br />
                                                                </div>
                                                                <div
                                                                    style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", width: 50 }}
                                                                    title="Visualizar Contrato de Aluguel"
                                                                >
                                                                    <ButtonTable
                                                                        visible={true}
                                                                        type={"primary"}
                                                                        icon={"fa fa-file"}
                                                                        event={() => {
                                                                            props.buscarArquivoContrato({ id: contrato.id, nome: `Contrato de Aluguel de Usina` });
                                                                            props.setArquivoPDF();
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </Grid>
                                                    );
                                                })
                                            ) : (
                                                <span style={{ marginLeft: 8 }}>Nenhum contrato incluído na análise ainda</span>
                                            )}
                                        </Row>
                                    </Grid>
                                </>
                            ) : (
                                <>
                                    <Select
                                        name="grupos_faturamento"
                                        options={props.listaGrupoFaturamento}
                                        label="Tipo de Faturamento"
                                        isMulti={true}
                                        cols="12 12 4 4"
                                        placeholder="Selecione o tipo de faturamento"
                                        value={props.filtro.grupos_faturamento}
                                        isClearable={false}
                                        isSearchable={false}
                                        onChange={(grupos_faturamento) => {
                                            props.setFiltro({
                                                ...props.filtro,
                                                grupos_faturamento,
                                            });
                                        }}
                                    />
                                    <Grid cols="12 12 3 3" style={{ visibility: exibirFiltroIrrigante ? "visible" : "hidden" }}>
                                        <Row style={{ paddingLeft: 12, paddingBottom: 12 }}>
                                            <b>Tipo de Atividade</b>
                                        </Row>
                                        <Row style={{ display: "flex", alignItems: "center" }}>
                                            <LabelAndCheckbox
                                                gridDisplay="flex"
                                                gridJustifyContent={window.innerWidth < 400 ? "start" : "center"}
                                                gridAlignItems="end"
                                                style={{ marginLeft: 12 }}
                                                component={LabelAndCheckbox}
                                                label="Irrigante"
                                                cols="6 6 6 6"
                                                value={props.filtro.irrigante}
                                                onChange={() => {
                                                    props.setFiltro({
                                                        ...props.filtro,
                                                        irrigante: !props.filtro.irrigante,
                                                    });
                                                }}
                                            />
                                            <LabelAndCheckbox
                                                gridDisplay="flex"
                                                gridJustifyContent={window.innerWidth < 400 ? "start" : "center"}
                                                gridAlignItems="end"
                                                style={{ marginLeft: 12 }}
                                                component={LabelAndCheckbox}
                                                label="Não-Irrigante"
                                                cols="6 6 6 6"
                                                value={props.filtro.naoIrrigante}
                                                onChange={() => {
                                                    props.setFiltro({
                                                        ...props.filtro,
                                                        naoIrrigante: !props.filtro.naoIrrigante,
                                                    });
                                                }}
                                            />
                                        </Row>
                                    </Grid>
                                </>
                            )}
                            {["contratoAluguel"].includes(props.tabSelecionada) ? null : (
                                <Select
                                    options={listarUCsFiltradas()}
                                    label={
                                        <div className="d-flex">
                                            <div className="mr-2">{"Unidades Consumidoras"}</div>
                                            {umaUcSelecionadaNoFiltro ? (
                                                <div
                                                    className="position-relative"
                                                    onClick={() => {
                                                        const ucFiltro = props.listaUnidadeConsumidora.find((uc) => uc.id == props.filtro.unidades_consumidoras[0].value);

                                                        if (!ucFiltro || !ucFiltro.gestor_concessionaria_energia) {
                                                            return window.alert("Ainda não há um contato definido para a unidade selecionada");
                                                        }

                                                        props.atualizarState({
                                                            exibirModalGestorConcessionaria: true,
                                                            itemSelecionado: ucFiltro,
                                                        });
                                                    }}
                                                >
                                                    <i style={{ fontSize: "1.2rem", "--bg": "#ffffff", "--fg": "#000000;" }} className="fas fa-id-badge inverter-hover"></i>
                                                    <i
                                                        style={{ fontSize: "0.7rem", paddingLeft: 4, color: "#009dff", position: "absolute", top: -4, right: -12 }}
                                                        className="fas fa-info-circle"
                                                    ></i>
                                                </div>
                                            ) : null}
                                        </div>
                                    }
                                    cols={
                                        ["custo", "consumo", "tarifa", "devolucao", "multas", "reativo", "horario"].includes(props.tabSelecionada)
                                            ? props.usuarioLogado.acesso_cliente
                                                ? "12 12 6 6"
                                                : "12 12 5 5"
                                            : "12 12 10 10"
                                    }
                                    placeholder="Selecione as UCs"
                                    isMulti={true}
                                    value={props.filtro.unidades_consumidoras}
                                    onChange={(ucsSelecionadas) => {
                                        if (props.tabSelecionada === "excedente") {
                                            const filtroAntesDeAtualizar = listarUCsFiltradas().filter((uc) =>
                                                props.filtro.unidades_consumidoras.find((ucf) => ucf.value == uc.id)
                                            );
                                            const filtroAtualizado = listarUCsFiltradas().filter((uc) => ucsSelecionadas.find((ucf) => ucf.value == uc.id));

                                            if (filtroAntesDeAtualizar.length && filtroAtualizado.length) {
                                                const filtroComRemota = filtroAntesDeAtualizar[0].remota && filtroAntesDeAtualizar[0].id_unidade_geradora; //pega a primeira
                                                const filtroComGeradora = !filtroComRemota;

                                                if (filtroComRemota && filtroAtualizado.find((ucf) => !ucf.remota)) {
                                                    window.confirm("Não é possível selecionar uma unidade geradora enquanto existir unidades remotas no filtro");
                                                    return;
                                                }

                                                if (filtroComGeradora && filtroAtualizado.find((ucf) => ucf.remota)) {
                                                    window.confirm("Não é possível selecionar uma unidade remota enquanto existir unidades geradoras no filtro");
                                                    return;
                                                }
                                            }
                                        }

                                        const ucQualquerDoFiltro = ucsSelecionadas[0] || {};
                                        const ucCompleta = props.listaUnidadeConsumidora.find((uc) => ucQualquerDoFiltro.value == uc.id) || {
                                            id_cliente: null,
                                        };
                                        props.setFiltro({
                                            ...props.filtro,
                                            unidades_consumidoras: [...ucsSelecionadas],
                                            id_cliente: props.filtro.id_cliente || ucCompleta.id_cliente,
                                        });
                                    }}
                                />
                            )}

                            {["custo", "consumo", "tarifa", "devolucao", "multas", "reativo", "horario"].includes(props.tabSelecionada) ? (
                                <>
                                    <Select
                                        style={{ color: "#000" }}
                                        options={listaAnos}
                                        label="Ano"
                                        cols={props.usuarioLogado.acesso_cliente ? "12 12 1 1" : "12 12 2 2"}
                                        placeholder="Selecione o ano"
                                        value={props.filtro["ano_" + props.tabSelecionada]}
                                        isClearable={false}
                                        isSearchable={false}
                                        onChange={(value) => props.handleChangeFiltroAno(value)}
                                    />

                                    <Select
                                        style={{ color: "#000" }}
                                        options={["Ano Civil (Janeiro à Dezembro)", "Ano Safra (Junho à Maio)"].map((item) => ({
                                            id: item,
                                            valor: item,
                                        }))}
                                        label="Período de Visualização"
                                        cols="12 12 3 3"
                                        placeholder="Selecione o ano"
                                        isClearable={false}
                                        isSearchable={false}
                                        value={props.filtro[props.tabSelecionada + "_ano_safra"] ? "Ano Safra (Junho à Maio)" : "Ano Civil (Janeiro à Dezembro)"}
                                        onChange={(value) => {
                                            const modoSafra = value === "Ano Safra (Junho à Maio)";
                                            props.handleChangePeriodoVisualizacao(modoSafra);
                                        }}
                                    />
                                </>
                            ) : null}
                        </>
                    )}
                    {props.tabSelecionada === "contratoAluguel" ? null : (
                        <Grid cols="12 12 2 2" style={{ paddingTop: 28, paddingRight: 15 }}>
                            <Button text="Analisar" type={"primary"} icon={"fa fa-sync"} event={() => props.handleAtualizar()} />
                        </Grid>
                    )}
                    {props.tabSelecionada == "demanda" ? (
                        <Grid cols="12 12 12 12">
                            <Row>
                                <Grid cols="12 12 4 3">
                                    <Button
                                        text="Contrato de Demanda Vigente"
                                        title="Contrato CUSD"
                                        type={"primary"}
                                        icon={"fa fa-check"}
                                        event={() => {
                                            if (!props.contratoDemanda) {
                                                return confirmDialog("Selecione uma única UC e clique em atualizar.", () => {});
                                            }
                                            if (props.contratoDemanda && !props.contratoDemanda.arquivo_cusd) {
                                                return confirmDialog("Nenhum arquivo de contrato(CUSD) encontrado.", () => {});
                                            }

                                            if (props.contratoDemanda && props.contratoDemanda.arquivo_cusd) {
                                                props.buscaCusd(props.contratoDemanda.id, "contrato_cusd");
                                                props.setArquivoPDF();
                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid cols="12 12 4 3">
                                    <Button
                                        title={ultimoRegistroEmAndamento ? "Existe um ajuste de demanda em andamento" : "Histórico"}
                                        text={<span>Histórico {ultimoRegistroEmAndamento ? <img height={20} width={20} src={ampulhetaCirculo} alt="" /> : null}</span>}
                                        type={"brown"}
                                        icon={"fas fa-book"}
                                        event={() => {
                                            if (!props.contratoDemanda) {
                                                return confirmDialog("Selecione uma única UC e clique em atualizar.", () => {});
                                            }

                                            if (props.contratoDemanda && !props.contratoDemanda.historico.length) {
                                                return confirmDialog("Não há registros no histórico.", () => {});
                                            }

                                            if (props.contratoDemanda && props.contratoDemanda.historico.length) {
                                                props.atualizarState({
                                                    exibirModalHistorico: true,
                                                    itemSelecionado: props.contratoDemanda,
                                                });
                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid cols="12 12 4 3">
                                    <Button
                                        text="Rede Elétrica Interna"
                                        title="Rede Elétrica Interna"
                                        type={"dark"}
                                        icon={"fas fa-network-wired"}
                                        event={() => {
                                            if (!props.filtro.unidades_consumidoras.length == 1) {
                                                return confirmDialog("Selecione uma única UC e clique em atualizar.", () => {});
                                            }

                                            if (props.filtro.unidades_consumidoras[0]) {
                                                props.buscarPdfUnifilarRedeInterna({
                                                    id_unidade_consumidora: props.filtro.unidades_consumidoras[0].value,
                                                    nome: `Mapa_unifilar_rede_interna`,
                                                });
                                            }
                                        }}
                                    />
                                </Grid>
                            </Row>
                        </Grid>
                    ) : null}
                </Row>
            </ContentCardHeader>
        </ContentCard>
    );
}

const mapStateToProps = (state) => ({
    usuarioLogado: state.auth.usuarioLogado,
    filtro: state.analise.filtro,
    listaCliente: state.analise.listaCliente,
    listaDemandaContratoTipo: state.analise.listaDemandaContratoTipo,
    listaAnosEmpenho: state.analise.listaAnosEmpenho,
    tabSelecionada: state.analise.tabSelecionada,
    contratoDemanda: state.analise.contratoDemanda,
    listaUnidadeConsumidora: state.analise.listaUnidadeConsumidora,
    listaGrupoFaturamento: state.cliente.listaGrupoFaturamento,
    listaContratoAluguelHistorico: state.analise.listaContratoAluguelHistorico,
    listaGeradorasContratoAluguelHistorico: state.analise.listaGeradorasContratoAluguelHistorico,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setFiltro,
            getListaAnosEmpenho,
            buscaCusd,
            buscarPdf,
            setArquivoPDF,
            getListaGraficoCustoAnual,
            getListaGraficoConsumoAnual,
            getListaGraficoValorDevolvidoAnual,
            getListaGraficoCustoMultaAnual,
            getListaGraficoCustoReativoAnual,
            getListaGraficoConsumoForaPonta,
            getListaAnaliseCativoMercadoLivreMensal,
            buscarPdfUnifilarRedeInterna,
            getListaContratosAluguelHistorico,
            getListaGeradorasContratosAluguelHistorico,
            buscarArquivoContrato,
        },
        dispatch
    );
export const FiltrosAnalise = connect(mapStateToProps, mapDispatchToProps)(FiltrosAnaliseComponent);
